import { monthlyFeePageFor } from "../monthlyFeePageFor";
import { CamerasMonthlyFeeItem } from "./CamerasMonthlyFeeItem";

export const CamerasMonthlyFees = monthlyFeePageFor(CamerasMonthlyFeeItem);
